import * as React from 'react';
import { JsonFormsDispatch, useJsonForms, withJsonFormsControlProps } from '@jsonforms/react';
import { inputProps } from '../interface/inputfieldProps';
import _ from 'lodash';
import { composePaths } from '@jsonforms/core';
import Grid from '@mui/material/Grid2';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { DataContext } from '../context/Context';

const DataGrid = function (props: inputProps) {
 const { data, uischema, path, schema, renderers } = props;
 const { theme,serviceProvider } = React.useContext(DataContext);
 const totalElements = data;
 const elementsToRender = [];
 const uischemaData = uischema?.config?.main;
 const ctx = useJsonForms();
 const dynamicStyle = React.useMemo(() => {
  return serviceProvider(
   ctx,
   {
    onClick: uischema.config?.main?.styleFunction || 'getStyle',
   },
   {
    event: { _reactName: 'onClick' },
    path,
   },
  );
 }, [data, path]);
 const componentStyle = { ...uischema.config?.style, ...dynamicStyle };
 function generateElements(index) {
  const element = uischema?.elements?.map((e, j) => {
   const childPath = composePaths(path, `${index}`);
   const widget = _.cloneDeep(e);
   let scopeArray = [];
   scopeArray = widget.scope?.split('/');
   widget.config.main.additionalData = {
    ...widget?.config?.main?.additionalData,
    tableButtonPath: scopeArray[scopeArray?.length - 1],
   };
   const { xs = 4, sm = 4, md = 4, lg = 4 } = e?.config?.layout || {};
   return (
    <Grid size={{ xs: xs, sm: sm, md: md, lg: lg }}>
     <JsonFormsDispatch
      schema={schema}
      uischema={{ ...widget }}
      path={childPath}
      key={childPath}
      renderers={renderers}
     />
    </Grid>
   );
  });
  return (
   <Grid
    size={{
     xs: uischema?.config?.cardLayout?.xs || 11.5,
     sm: uischema?.config?.cardLayout?.sm || 11.5,
     md: uischema?.config?.cardLayout?.md || 6,
     lg: uischema?.config?.cardLayout?.lg || 4,
    }}
   >
    <Paper
     sx={{
      ...componentStyle.cardStyle,
     }}
     elevation={uischemaData.elevation || 2}
    >
     <Grid
      container
      spacing={2}
      size={12}
      sx={{
       justifyContent: 'center',
       margin: '1px',
       ':hover': {
        background: '#eef2f6',
        border: '4px solid white',
        borderRadius: '10px',
        boxShadow: '5px 5px 10px #eef2f6',
       },
       ...componentStyle.innerGridStyle,
      }}
     >
      {element}
     </Grid>
    </Paper>
   </Grid>
  );
 }
 for (let i = 0; i < totalElements?.length; i++) {
  const element = generateElements(i);
  elementsToRender.push(element);
 }
 return (
  <div
   style={{
    background: '#ffffff',
    ...theme.WrapperStyle,
    ...componentStyle.containerStyle,
   }}
  >
   {uischemaData?.label && (
    <Box>
     <Typography
      component={'div'}
      sx={{
       padding: '10px',
       paddingLeft: '28px',
       fontSize: { xs: '16px', sm: '20px' },
       fontFamily: 'Poppins',
       fontWeight: 500,
       color: 'inherit',
       ...componentStyle.labelStyle,
      }}
     >
      {uischemaData.label}
     </Typography>
     {uischema?.config?.main?.divider && (
      <Divider sx={{ paddingTop: '8px' }} variant='fullWidth'></Divider>
     )}
    </Box>
   )}
   <Grid
    container
    rowSpacing={uischema.config?.main?.rowSpacing || 2}
    columnSpacing={uischema.config?.main?.columnSpacingSpacing || 2}
    spacing={uischema.config?.main?.spacing || 2}
    size={{
     xs: 11.8,
     sm: 11.8,
     md: 11.5,
     lg: 11.5,
    }}
    sx={{
     gap: uischema.config?.main?.gap,
     justifyContent: uischema.config?.main?.justifyContent || 'flex-start',
     borderRadius: '19px',
     padding: '20px',
     marginRight: 'auto',
     marginLeft: 'auto',
     overflowX: uischemaData?.height ? 'auto' : 'none',
     height: uischemaData?.height || 'auto',
     ...componentStyle.gridContainerStyle,
    }}
   >
    {data?.length === 0 || !data ? (
     <>
      <Grid
       size={12}
       sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...componentStyle.cardStyle,
       }}
      >
       <Typography
        component={'div'}
        sx={{
         fontSize: { xs: '14px', sm: '16px' },
         fontFamily: 'monospace',
         color: '#bcc8d0',
         textAlign: 'center',
         padding: '20px 0',
        }}
       >
        No data to display
       </Typography>
      </Grid>
     </>
    ) : (
     elementsToRender.map((e) => e)
    )}
   </Grid>
  </div>
 );
};
export default withJsonFormsControlProps(DataGrid);
